<template>
  <td>
    <router-link :to="`/systemuser/kartei/${model.id}`">{{ name }}</router-link>
  </td>
</template>

<script>
export default {
  props: ["content", "model"],
  computed: {
    name() {
      return this.content || "-- Kein Name --";
    }
  }
};
</script>

<style></style>
